import {
    SET_ADDRESS_INFO,
    CLEAR_ADDRESS_INFO,
    GET_REGION_BY_TYPE_ID,
    EDIT_REGION
} from '../mutationTypes'
import {
    getRegion
} from '@/models/common'
// import { setLocalConfig } from '@/utils/storage'
// import Vue from 'vue'
const state = {
    delivery: {
        delivery_id: '', // 设置delivery_id
        consignee: '', // 提货人姓名
        address: '', // 详细地址
        phone_tel: '', // 手机号
        region_name: '' // 地区名
    },
    area: {
        province_list: [],
        city_list: [],
        county_list: [],
        selected_city: '',
        selected_prov: '',
        selected_county: ''
    }
}

const mutations = {
    // 设置地址信息
    [SET_ADDRESS_INFO] (state, data) {
        state.delivery = {
            ...data
        }
    },
    [CLEAR_ADDRESS_INFO] (state, data) {
        state.delivery = {
            delivery_id: '', // 设置delivery_id
            consignee: '', // 提货人姓名
            address: '', // 详细地址
            phone_tel: '', // 手机号
            region_name: '' // 地区名
        }
    },
    [GET_REGION_BY_TYPE_ID] (state, data) {
        if (data.type === 1) {
            state.area.province_list = data.area
            state.area.selected_prov =  state.area.selected_prov || state.area.province_list[0]
        } else if (data.type === 2) {
            state.area.city_list = data.area
            state.area.selected_city = state.area.selected_city || state.area.city_list[0]
        } else if (data.type === 3) {
            state.area.county_list = data.area
            state.area.selected_county = state.area.selected_county || state.area.county_list[0]
        }
    },
    [EDIT_REGION] (state, data) {
        // if (data.type === 1) {
        state.area.selected_prov = data.selected_prov
        // } else if (data.type === 2) {
        state.area.selected_city = data.selected_city
        // } else if (data.type === 3) {
        state.area.selected_county = data.selected_county
        // }
    }
}

export const actions = {
    // 记录收获地址
    setAddressInfo ({
        commit
    }, data) {
        commit(SET_ADDRESS_INFO, data)
    },
    // 清理地址信息
    clearAddressInfo ({
        commit
    }, data) {
        commit(CLEAR_ADDRESS_INFO, data)
    },
    async getRegion ({
        commit
    }, params) {
        const data = await getRegion(params)
        commit(GET_REGION_BY_TYPE_ID, {
            area: data.list,
            type: params.region_type
        })
    },
    editRegion ({
        commit
    }, params) {
        commit(EDIT_REGION, params)
    }
}

export const getters = {
    addressInfo: state => state.editAddress.delivery,
    area (state) {
        return state.editAddress.area
    }
}

export default {
    state,
    mutations
}
